import AssetUniverseStep from './AssetUniverseStep.tsx';
import type { AssetOptimizerInputFields } from '../AssetOptimizer.validation.ts';
import type { StepConfig } from '../../../../../technical/wizard/StepConfig.ts';
import type { NotVerifiedAssetWithId } from 'components/market/asset/AssetService.tsx';

export const config = ({
  assets,
  assetIdToClusterToGroup,
  goToNextStep,
  syncWithOutlook = true,
  hideInitialPortfolio = false,
}: {
  assets: NotVerifiedAssetWithId[];
  assetIdToClusterToGroup: Record<string, Record<string, string>>;
  goToNextStep: () => void;
  syncWithOutlook?: boolean;
  hideInitialPortfolio: boolean;
}): StepConfig<AssetOptimizerInputFields> => ({
  label: 'Asset universe',
  element: (
    <AssetUniverseStep
      assets={assets}
      goToNextStep={goToNextStep}
      assetIdToClusterToGroup={assetIdToClusterToGroup}
      syncWithOutlook={syncWithOutlook}
      hideInitialPortfolio={hideInitialPortfolio}
    />
  ),
  fields: ['universe'],
});
